import * as types from "./types";

export function toggleScheduleType(val) {
  return {
    type: types.TOGGLE_SCHEDULE_TYPE,
    val
  };
}

export function toggleScheduleInterval(val) {
  return {
    type: types.TOGGLE_SCHEDULE_INTERVAL,
    val
  };
}

export function toggleScheduleStartTime(val) {
  return {
    type: types.TOGGLE_SCHEDULE_START_TIME,
    val
  };
}

export function toggleScheduleDays(val) {
  return {
    type: types.TOGGLE_SCHEDULE_DAYS,
    val
  };
}

export function toggleScheduleMonths(val) {
  return {
    type: types.TOGGLE_SCHEDULE_MONTHS,
    val
  };
}

export function toggleScheduleMonthDays(val) {
  return {
    type: types.TOGGLE_SCHEDULE_MONTH_DAYS,
    val
  };
}

export function toggleScheduleRetention(retentionType, val) {
  return {
    type: types.TOGGLE_SCHEDULE_RETENTION,
    retentionType,
    val
  };
}

export function toggleScheduleDevice(activityType) {
  return {
    type: types.TOGGLE_SCHEDULE_DEVICE,
    activityType
  };
}

export function toggleScheduleLoginDetails(detailsType, val) {
  return {
    type: types.TOGGLE_SCHEDULE_LOGIN_DETAILS,
    detailsType,
    val
  };
}

export function toggleNotificationEnable() {
  return {
    type: types.TOGGLE_NOTIFICATION_ENABLE
  };
}

export function changeNotificationCurrentEmail(val) {
  return {
    type: types.CHANGE_NOTIFICATION_CURRENT_EMAIL,
    val
  };
}

export function addNotificationEmail() {
  return {
    type: types.ADD_NOTIFICATION_EMAIL
  };
}

export function addMultipleNotificationEmail(correctEmails, wrongEmails) {
  return {
    type: types.ADD_MULTIPLE_NOTIFICATION_EMAIL,
    correctEmails,
    wrongEmails
  };
}

export function removeNotificationEmail(index) {
  return {
    type: types.TOGGLE_NOTIFICATION_REMOVE_EMAIL,
    index
  };
}

export function changeNotificationSMTPSetting(settingType, val) {
  return {
    type: types.CHANGE_NOTIFICATION_SMTP_SETTING,
    settingType,
    val
  };
}

export function toggleNotificationOperationStatus(statusType) {
  return {
    type: types.TOGGLE_NOTIFICATION_OPERATION_STATUS,
    statusType
  };
}

export function toggleNotificationOnDesktop() {
  return {
    type: types.TOGGLE_NOTIFY_ON_DESKTOP
  };
}

export function toggleSourceType(val) {
  return {
    type: types.TOGGLE_SOURCE_TYPE,
    val
  };
}

export function toggleSourceDevice(deviceId) {
  return {
    type: types.TOGGLE_SOURCE_DEVICE,
    deviceId
  };
}

export function toggleSourceVolume(deviceId, volId) {
  return {
    type: types.TOGGLE_SOURCE_VOLUME,
    deviceId,
    volId
  };
}

export function fetchBackupSettingsStart(clientUUID) {
  return {
    type: types.FETCH_BACKUP_SETTINGS_START,
    clientUUID
  };
}

export function fetchBackupSettingsSuccess(backupSettings) {
  return {
    type: types.FETCH_BACKUP_SETTINGS_SUCCESS,
    backupSettings
  };
}

export function fetchBackupSettingsFailure(data) {
  return {
    type: types.FETCH_BACKUP_SETTINGS_FAILURE,
    data
  };
}

export function saveBackupSettingsStart(backupSettings) {
  return {
    type: types.SAVE_BACKUP_SETTINGS_START,
    backupSettings
  };
}

export function saveBackupSettingsSuccess() {
  return {
    type: types.SAVE_BACKUP_SETTINGS_SUCCESS
  };
}

export function updateBackupSettingsStart(settings, clientUUID) {
  return {
    type: types.UPDATE_BACKUP_SETTINGS_START,
    settings,
    clientUUID
  };
}

export function backupSettingsChanged(machine) {
  return {
    type: types.BACKUP_SETTINGS_CHANGED,
    clientUUID: machine.clientUUID
  };
}

export function clearBackupSettings() {
  return {
    type: types.CLEAR_BACKUP_SETTINGS
  };
}

export function toggleEncryptionType(encryption) {
  return {
    type: types.TOGGLE_ENCRYPTION_TYPE,
    encryption
  };
}

export function changeEncryptionKey(key, value) {
  return {
    type: types.CHANGE_ENCRYPTION_KEY,
    key,
    value
  };
}

export function removeSlidingPopNotification() {
  return {
    type: types.REMOVE_SLIDING_POPUP_NOTIFICATION
  };
}

export function cancelEditBackupSetting(settings) {
  return {
    type: types.CANCEL_EDIT_BACKUP_SETTING,
    settings
  };
}

export function initiateFullBackup(clientUUID) {
  return {
    type: types.INITIATE_FULL_BACKUP,
    clientUUID
  };
}

export function removeMachineStart(clientUUID, fromHeader = false) {
  return {
    type: types.REMOVE_MACHINE_START,
    clientUUID,
    fromHeader
  };
}

export function closeRefresh() {
  return {
    type: types.CLOSE_REFRESH
  };
}

export function toggleCleanupScheduleCount(scheduleCount) {
  return {
    type: types.TOGGLE_CLEANUP_SCHEDULE_COUNT,
    scheduleCount
  };
}

export function toggleCleanupMonths(months) {
  return {
    type: types.TOGGLE_CLEANUP_MONTHS,
    months
  };
}

export function toggleCleanupMonthsCheck() {
  return {
    type: types.TOGGLE_CLEANUP_MONTHS_CHECK
  };
}

export function togglePerformanceSpeedLimit() {
  return {
    type: types.TOGGLE_PERFORMANCE_SPEED_LIMIT
  };
}

export function togglePerformancePriority(priority) {
  return {
    type: types.TOGGLE_PERFORMANCE_PRIORITY,
    priority
  };
}

export function togglePerformanceSpeed(speed, unit) {
  return {
    type: types.TOGGLE_PERFORMANCE_SPEED,
    speed,
    unit
  };
}

export function toggleSkipDiskErr(ignoreBadSectors) {
  return {
    type: types.TOGGLE_SKIP_DISK_ERR,
    ignoreBadSectors
  };
}

export function preBackupSettingsChanged(clientUUID) {
  return {
    type: types.PRE_BACKUP_SETTINGS_CHANGED,
    clientUUID
  };
}

export function accountSettingsChanged() {
  return {
    type: types.ACCOUNT_SETTINGS_CHANGED
  };
}

export function toggleCutOffTime(val, time) {
  return {
    type: types.TOGGLE_CUT_OFF_TIME,
    val,
    time
  };
}

export function toggleCutOffEnable(enable) {
  return {
    type: types.TOGGLE_CUT_OFF_ENABLE,
    enable
  };
}

export function addClientsToPlanStart(data, isEnableClient, srPoint) {
  return {
    type: types.ADD_CLIENTS_TO_PLAN_START,
    data,
    isEnableClient,
    srPoint
  };
}

export function removeMachineFromHeaderSuccess() {
  return {
    type: types.REMOVE_MACHINE_FROM_HEADER_SUCCESS
  };
}

export function removeMachineFromHeaderFailure() {
  return {
    type: types.REMOVE_MACHINE_FROM_HEADER_FAILURE
  };
}

export function resetRemoveMachinesList() {
  return {
    type: types.RESET_REMOVE_MACHINES_LIST
  };
}
